import { render, staticRenderFns } from "./ctaButton.vue?vue&type=template&id=158f8347&scoped=true&"
import script from "./ctaButton.vue?vue&type=script&lang=ts&"
export * from "./ctaButton.vue?vue&type=script&lang=ts&"
import style0 from "./ctaButton.vue?vue&type=style&index=0&id=158f8347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f8347",
  null
  
)

export default component.exports